/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  ViewChild,
  OnInit, ChangeDetectorRef
} from '@angular/core';

import { Logger                } from '@/util/logger';

import { MatSidenav }            from '@angular/material/sidenav';
import { UserService }           from "@/services/user.service";
import {IUserRow} from "@/screens/administration/i.user.row";
import {first} from "rxjs/operators";

@Component({
  standalone: false,
  templateUrl: 'admin.component.html'
})

/**
 *
 * @class AdminComponent
 *
 * @brief main administration page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class AdminComponent implements OnInit {

  /** the total number of open approvals */
  public pendingCount: number = 0;

  /** the total number of users */
  public userCount: number = 0;

  /** size of postgresql database on disk */
  public dbSize: number = 0;

  @ViewChild('adminsidenav')
  public         nav: MatSidenav;

  /** standard constructor */
  constructor(
    private users: UserService,
    private cdRef: ChangeDetectorRef
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[AdminComponent] init...');

    /*
     * fetch the disk hogs report, so we can get the total number of users and how much space
     * they are eating.
     *
     */

    let ac: AdminComponent = this;

    ac.pendingCount = 0;
    ac.userCount    = 0;

    ac.users.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          let rows: IUserRow[] = [];

          if (data.result) {

            rows = data.result;
          }

          rows.forEach((item: IUserRow) => {

            if (item.is_pending) {

              ac.pendingCount++;
            }

            ac.userCount++;

          });

          ac.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[AdminComponent] could not fetch user list: `, error);

        }

      });


  }

  /** expand/collapse the sidebar navigation panel */
  toggleSidebar() {

    this.nav.toggle();
  }

}

